import { NFTCache, type nft } from '#types/loreTypes'
import generateRootMeta from './rootMeta'

const generateMetaProfileMeta = ({
	origin = 'https://atomiclore.io',
	path,
	nft,
}: {
	origin?: string
	path: string
	nft?: NFTCache
}) => {
	if (nft) {
		try {
			let page
			let chain
			let contractAddress
			let tokenId
			let queryParams = ''
			const splitParams = path.split('/').slice(1)
			if (splitParams.length >= 3) {
				page = splitParams[0]
				chain = splitParams[1]
				if (chain == 'solana') {
					tokenId = splitParams[2]
				}
				if (chain == 'ethereum') {
					contractAddress = splitParams[2]
					tokenId = splitParams[3]
				}
				if (
					page == 'metadataProfile' &&
					chain == 'ethereum' &&
					contractAddress &&
					tokenId
				) {
					queryParams = `?contractAddress=${contractAddress}&tokenId=${tokenId}`
				}
				if (page == 'metadataProfile' && chain == 'solana' && tokenId) {
					queryParams = `?tokenId=${tokenId}`
				}
				const ogImageUrl = `${origin}/metadataImage${queryParams}`
				return [
					{
						title: nft
							? `Atomic Lore for ${nft.name}`
							: import.meta.env.VITE_APP_NAME
								? import.meta.env.VITE_APP_NAME
								: 'Atomic Lore',
					},
					{
						property: 'og:title',
						content: nft
							? `Atomic Lore for ${nft.name}`
							: import.meta.env.VITE_APP_NAME
								? import.meta.env.VITE_APP_NAME
								: 'Atomic Lore',
					},
					{ property: 'og:url', content: origin + path },
					{
						name: 'description',
						content: nft
							? `Crytophraphically signed story and history for ${nft.name}, beautifully displayed`
							: import.meta.env.VITE_APP_DESCRIPTION
								? import.meta.env.VITE_APP_DESCRIPTION
								: 'A tool to explore NFT history, by Atomic Form',
					},
					{
						property: 'og:description',
						content: nft
							? `Crytophraphically signed story and history for ${nft.name}, beautifully displayed`
							: import.meta.env.VITE_APP_DESCRIPTION
								? import.meta.env.VITE_APP_DESCRIPTION
								: 'A tool to explore NFT history, by Atomic Form',
					},
					{ property: 'og:site_name', content: 'atomiclore.io' },
					// IMAGE
					{ name: 'image', content: ogImageUrl },
					{ property: 'og:image', content: ogImageUrl },
					{ property: 'og:image:width', content: '1200px' },
					{ property: 'og:image:height', content: '630px' },
					// TWITTER / SLACK
					{ name: 'twitter:image', content: ogImageUrl },
					{ name: 'twitter:card', content: 'summary_large_image' },
					{ name: 'twitter:site', content: '@atomicform' },
					{ name: 'twitter:creator', content: '@atomicform' },
					{
						name: 'twitter:description',
						content: nft
							? `Crytophraphically signed story and history for ${nft.name}, beautifully displayed`
							: import.meta.env.VITE_APP_DESCRIPTION
								? import.meta.env.VITE_APP_DESCRIPTION
								: 'A tool to explore NFT history, by Atomic Form',
					},
					{
						name: 'twitter:title',
						content: nft
							? `Atomic Lore for ${nft.name}`
							: import.meta.env.VITE_APP_NAME
								? import.meta.env.VITE_APP_NAME
								: 'Atomic Lore',
					},
				]
			} else {
				const metaPayload = generateRootMeta({ path, origin })
				return metaPayload
			}
		} catch (e) {
			console.error('ERROR GENERATING METATAGS FOR METADATA PROFILE', e)
			const metaPayload = generateRootMeta({ path, origin })
			return metaPayload
		}
	} else {
		const metaPayload = generateRootMeta({ path, origin })
		return metaPayload
	}
}

export default generateMetaProfileMeta
